
export default {
  name: "SaveMoreOffers",
  props: {
    title: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    },
    slaveStore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inViewLen: 4,
      isShowAll: false
    }
  },
  computed: {
    itemsLen() {
      return this.items.length
    },
    isShowViewBtn() {
      return this.itemsLen > this.inViewLen
    },
    displayItems() {
      if (!this.isShowAll && this.isShowViewBtn) {
        return this.items.slice(0, this.inViewLen)
      }
      return this.items
    }
  },
  watch: {
    items: {
      handler(newVal) {
        console.log(newVal, "newValnewValnewVal")
      },
      immediate: true
    }
  },
  methods: {
    // 最多展示14个
    getImgUrls(item) {
      return Object.values(item.uuidMap || {}).slice(0, 14)
    },
    getClass(index) {
      // 最后一个item && 为奇数
      return this.itemsLen - 1 === index && this.itemsLen % 2 !== 0 ? "offers-item-full" : ""
    },
    addMore(item) {
      console.log("addMore===>", item)
      this.$emit("addMore", item)
    },
    toggleViewBtnClick() {
      this.isShowAll = !this.isShowAll
    }
  }
}
